import { API_REQUESTS } from "./types";

export const API_ROUTES = {
  [API_REQUESTS.CHECK_IF_CREDENTIALS_VALID]: "applicant/check/user_password",
  [API_REQUESTS.CHECK_IF_SURVEY_LINKED_TO_APPLICANT_GROUP]: "applicant/check/group",
  [API_REQUESTS.CREATE_APPLICANT_SESSION]: "applicant/create",
  [API_REQUESTS.CHECK_USER_ANSWERS_STATUS]: "answers/user/status/check",
  [API_REQUESTS.CREATE_NON_APPLICANT_SESSION]: "answers/user/save",

  [API_REQUESTS.GET_SPLASH_PAGE_BY_ROUTE]: "splash_pages/:surveyRoute",
  [API_REQUESTS.GET_SURVEY_BY_ID]: "surveys/:surveyId",
  [API_REQUESTS.CHECK_USER_ANSWERS]: "answers/user",

  [API_REQUESTS.SAVE_ANSWERS]: "answers/save",
  [API_REQUESTS.FINISH_SURVEY]: "answers/finish",
};
